import * as React from 'react';
import { Page, PageContent, PageHeader } from '../components/common';
import { Helmet } from 'react-helmet';

interface Props {}
const TermsPage: React.StatelessComponent<Props> = props => {
	return (
		<Page>
			<Helmet>
				<meta charSet="utf-8"/>
				<meta
					name="description"
					content={`A description of Mosaic Life's Terms of Use policies.`}
				/>
				<title>Terms of Use | Mosaic Life</title>
			</Helmet>
			<PageContent>
				<PageHeader title="Terms & Conditions" />
				<p>
					<strong>Acceptance Of Conditions</strong> - By accessing and browsing this web site, visitors accept, without
					limitation or qualification, the Terms and Conditions contained below and all applicable laws. First Canadian
					Group of Companies (First Canadian Insurance Corporation, Millennium Insurance Corporation, Data Gathering
					Service Inc. and Platinum Tire and Rim Protection Inc.) may at any time revise these Terms and Conditions by
					updating this posting. Visitors agree to be bound by such revisions, and should periodically revisit this page
					to review the current Terms and Conditions.
				</p>
				<p>
					<strong>Information Accuracy</strong> - Although the contents of this website are believed to be reliable when
					posted, First Canadian Group of Companies cannot guarantee this information to be current, accurate or
					complete. The information is subject to modification and updating from time to time without notice. Prior to
					acting upon any of this information, please contact your independent financial advisor to verify its accuracy.
				</p>
				<p>
					<strong>Web Site Content</strong> - The information on this website does not constitute an offer to buy or
					sell products or services and is not intended to provide professional advice including, without limitation,
					financial, legal, accounting or tax advice. The information should not be relied upon in this regard. Please
					contact your independent financial advisor for assistance.
				</p>
				<p>
					<strong>Product Availability</strong> - The products and services referred to on this website may not be
					available in all geographic regions. First Canadian Group of Companies products and services are only
					available in provinces and territories of Canada and other jurisdictions in accordance with the local law and
					where they may be legally offered for sale. All products and services are subject to the terms, conditions and
					limitations of the applicable agreements.
				</p>
				<p>
					<strong>Trademarks And Copyright</strong> - All contents of this web site are the copyright of First Canadian
					Group of Companies and are protected under the copyright laws of Canada and other countries. All rights
					reserved. In addition, certain information on this web site may be copyrighted by others. The information on
					this web site shall only be copied for personal use and may not be reproduced, or distributed for any other
					purpose in whole or in part without the prior written permission of First Canadian Group of Companies. Any
					infringement of First Canadian Group of Companies rights will result in appropriate legal action.
				</p>
				<p>
					<strong>Hypertext Links</strong> - This web site may facilitate access by hypertext links to other worldwide
					web sites. These hypertext links are entirely independent of this web site and shall NOT in any manner be
					construed as any reflection on or any affiliation with or endorsement of such site or entity or its respective
					products, services or contributions to this web site. First Canadian Group of Companies has not reviewed the
					content linked to. The right to reproduce and use the content linked to is (1) subject to the conditions that
					the respective owners may impose, and (2) is at your own risk.
				</p>
				<p>
					<strong>Privacy And Security</strong> - First Canadian Group of Companies attempts to maintain security
					efforts which are consistent with standard industry practice in Canada. However, complete privacy,
					confidentiality and security are not yet possible over the Internet. Therefore, First Canadian Group of
					Companies shall not be responsible or liable for any harm or loss, which may be suffered by any party,
					resulting from the use, communication or transmission of any information, including private, confidential or
					sensitive information to or from this web site.
				</p>
				<p>
					<strong>E-mail</strong> - First Canadian Group of Companies will not accept transactions or instructions by
					Internet E-Mail messages, unless otherwise specified. However, questions of a general nature or inquiries may
					be communicated by E-Mail messages. First Canadian Group of Companies discourages customers from sending
					confidential and personal information by Internet E-Mail messages, as the security of these messages cannot be
					guaranteed. Any person who chooses to send a message by E-Mail does so at his or her own risk and First
					Canadian Group of Companies will not be held responsible for any damages or losses incurred as a result. Any
					communication transmitted to us by electronic mail, regular post or otherwise becomes the property of First
					Canadian Group of Companies or its affiliates and may be used for any purpose. First Canadian Group of
					Companies is free to use any idea contained in any communication sent to us for any purpose whatsoever,
					including, but not limited to, developing, manufacturing and marketing products using such information.
				</p>
				<p>
					<strong>Liability</strong> - First Canadian Group of Companies, its officers, directors, employees or any
					persons associated with the creation of this web site, are NOT responsible in any manner whatsoever for any
					harm, loss or damage that may arise in connection with or through the use of this web site including, without
					limitation, any direct, indirect, special, third party or consequential damages, howsoever caused. By
					accessing and browsing this web site, visitors agree that the laws of Alberta and Canada apply to any issue
					that might arise with First Canadian Group of Companies regarding this site, and to settle such dispute in the
					courts of Alberta.
				</p>
			</PageContent>
		</Page>
	);
};
export default TermsPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/TermsPage.tsx